export default __webpack_public_path__ + "static/media/menu-close-white.48e1eb8a.svg";